import { render, staticRenderFns } from "./addNegativeCitis.vue?vue&type=template&id=92168a92&scoped=true"
import script from "./addNegativeCitis.vue?vue&type=script&lang=js"
export * from "./addNegativeCitis.vue?vue&type=script&lang=js"
import style0 from "./addNegativeCitis.vue?vue&type=style&index=0&id=92168a92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92168a92",
  null
  
)

export default component.exports